import { exportRequestsFactory } from '@eas/common-web';
import { ExportTags } from '@enums';

export const ExportRequests = exportRequestsFactory({
  exportTag: ExportTags.EXPORT_REQUESTS,
});
